export default "__VITE_ASSET__3187e9b1__"